import { type ComponentPropsWithoutRef } from 'react';
import type { AvatarData } from '@/api/gen/_model/avatarData';
import { type PlanType } from '@/types';
import { type AvatarSize, SIZE_PIXEL_MAP } from '../constants/avatar.constants';
import { BakedAvatar } from './BakedAvatar';
import { FallbackAvatar } from './FallbackAvatar';
import { SpriteAvatar } from './SpriteAvatar';
type BaseUserAvatarProps = ComponentPropsWithoutRef<'div'> & {
  avatarData?: AvatarData | null;
  planType?: PlanType;
  backgroundColor?: string;
};
type BakedUserAvatarProps = BaseUserAvatarProps & {
  useSprite?: false | undefined;
  size?: AvatarSize;
  spritePixelSize?: never;
};
type SpriteBySizeUserAvatarProps = BaseUserAvatarProps & {
  useSprite: true;
  size?: AvatarSize;
  spritePixelSize?: never;
};
type SpriteByPixelUserAvatarProps = BaseUserAvatarProps & {
  useSprite: true;
  size?: never;
  spritePixelSize: number;
};
type UserAvatarProps = BakedUserAvatarProps | SpriteBySizeUserAvatarProps | SpriteByPixelUserAvatarProps;
export const UserAvatar = ({
  avatarData,
  size,
  planType,
  useSprite,
  backgroundColor,
  spritePixelSize,
  className,
  style,
  ...props
}: UserAvatarProps) => {
  if (useSprite) {
    const resolvedSpritePixelSize = spritePixelSize ?? SIZE_PIXEL_MAP[size ?? 'xs'];
    if (!avatarData) {
      return <FallbackAvatar size={size ?? 'xs'} planType={planType} backgroundColor={backgroundColor} className={className} style={{
        width: resolvedSpritePixelSize,
        height: resolvedSpritePixelSize,
        ...style
      }} {...props} />;
    }
    return <SpriteAvatar avatarData={avatarData} backgroundColor={backgroundColor} spritePixelSize={resolvedSpritePixelSize} className={className} style={style} {...props} />;
  }
  const resolvedSize = size ?? 'xs';
  if (!avatarData) {
    return <FallbackAvatar size={resolvedSize} planType={planType} backgroundColor={backgroundColor} className={className} style={style} {...props} />;
  }
  return <BakedAvatar avatarData={avatarData} size={resolvedSize} planType={planType} backgroundColor={backgroundColor} className={className} style={style} {...props} data-sentry-element="BakedAvatar" data-sentry-component="UserAvatar" data-sentry-source-file="UserAvatar.tsx" />;
};